/** Лига заглушки. */
import type { PlayerState } from "../api";

export function sampleLeagueFields(): Pick<PlayerState, "league"> {
  return {
    league: null,
  };
}
